import { createI18n } from 'vue-i18n';
import frBase from './locales/fr.json';
import enBase from './locales/en.json';
import frAllergens from './locales/fr/allergens.json';
import enAllergens from './locales/en/allergens.json'; 

const fr = {
  ...frBase,
  ...frAllergens,
};

const en = {
  ...enBase,
  ...enAllergens, // tu peux aussi avoir un allergens_en.json si besoin
};

const i18n = createI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages: { en, fr },
});

// this.$i18n.locale = 'en'; ou 'fr' pour changer la langue dynamiquement
// <h1>{{ $t('welcome') }}</h1> pour y faire appel dans les composants Vue

export default i18n;